<template>
	<div class="v-recurrent">
		<div class="v-recurrent-header">
			<div class="v-recurrent-field">
				<p class="v-recurrent-field__title">Сумма к оплате:</p>
				<p class="v-recurrent-field__error" v-show="erramount.length > 0" v-html="erramount" />
				<input
					class="v-recurrent-field__input"
					type="tel"
					:value="curPay"
					readonly
				/>
			</div>
			<div class="v-recurrent-field" v-if="PdlData.SumForRenewal !== undefined &&
			PdlData.SumForRenewal !== null">
				<p class="v-recurrent-field__title">Сумма лонгации:</p>
				<input
					class="v-recurrent-field__input"
					type="tel"
					:value="PdlData.SumForRenewal"
					readonly
				/>
			</div>
		</div>
		<div class="v-recurrent-cards">
			<div
				class="v-recurrent-cards-recurrent"
				v-if="PdlData.PAYMENT_TYPE === 'TinkoffE2C'"
			>
				<div class="item cardView">
					<img svg-inline alt="" :src="imagePath" class="falseSvg">
					<span>{{ this.PdlData.tinkoffE2C_cardSelected.pan }}</span>
					<button class="v-button" @click="makePayment">Оплатить</button>
				</div>
			</div>
			<div
				class="v-recurrent-cards-recurrent"
				v-else
			>
				<div class="item cardView">
					<span>Карты не найдено</span>					
				</div>
			</div>
			<div class="item cardView">
				<p>СМС с ссылкой на платежную страницу</p>
				<button class="v-button" v-on:click="sendSMS(2)">Отправить</button>
			</div>
			<div class="item cardView" >
				<p>СМС с ссылкой на лонгацию</p>
				<button class="v-button" v-on:click="sendSMS(1)">Отправить</button>
			</div>
		</div>
	</div>
</template>


<script>
 export default {
	name: 'recurrent',
	props: {
		PdlData:{
			type:Object,
			default () {
				return {}
			},
		},
	},
	data () {
		return {
			erramount: '',
			curPay: 0,
			path: '',
		}
	},
	components: {
    formInput: () => import('@/components/forms/formInput'),
	},
	mounted () {
		let summ = Math.ceil(this.PdlData.DebtAll);
		if(summ > 0) {
			this.curPay = parseInt(summ, 10);
		}

	},
	computed: {
		imagePath () {
			let urlPath = 'https://lnd.msk.finmoll.com';
      return urlPath+this.PdlData.tinkoffE2C_cardSelected.cardType;
		},
	},
	methods:{
		sendSMS(type){
			this.$store.commit('showModal');
			this.$store.commit('userCanNotCloseModal');
			this.$store.commit('setContent', 'Отправкa запроса');
			this.$external.universalRequest({
					externalType: "zita",
					action: "smsSemdFromPunishment",
					DemandID: parseInt(this.PdlData.DlCode),
					TypeSms:type
			}).then(res=>{
				this.$store.commit('setContent', res.result);
			}).catch(res=>{
				if ( res.errorCode > 0  ) {
					this.$store.commit('setContent', res.errorMsg);
				} else {
					this.$store.commit('setContent', 'Ошибка' + ' ' + res.errorCode + ': ' + res.errorMsg);
				}
			}).finally(()=>{
				this.$store.commit('userCanCloseModal');
			});
		},
		makePayment () {
			if (this.erramount.length > 0) {
				alert(this.erramount);
				return false;
			}

			let paymentData= {
				"PAYMENT_TYPE": this.PdlData.PAYMENT_TYPE,
				"demand": parseInt(this.PdlData.DlCode),
				"tinkoffE2C_cardSelected": this.PdlData.tinkoffE2C_cardSelected,
				"amount": parseInt(this.curPay,10)
			};
			this.$store.commit('showModal');
			this.$store.commit('userCanNotCloseModal');
			this.$store.commit('setContent', 'Отправкa запроса');
			this.$external.universalRequest({
				externalType: "zita",
				"action": "setRecurrentData",
				"JsonData": {
					"userId": localStorage.getItem('UserID'),
					"sessionKey": localStorage.getItem('SessionKey'),
					"source": "cclocal",
					"type": "recurrent",
					"paymentData": paymentData
				}
			})
			.then(res => {
				console.log(res);
				this.$store.commit('setContent', 'Запрос выполенен');
			}).catch(err => {
				if ( err.errorCode > 0  ) {
					this.$store.commit('setContent', err.errorMsg);
				} else {
					this.$store.commit('setContent', 'Ошибка' + ' ' + err.errorCode + ': ' + err.errorMsg);
				}
			}).finally(()=>{
				this.$store.commit('userCanCloseModal');
			});
		},
		redirectToPaymentQiwi () {
			this.$router.push('/payment');
		},
		amountCheck () {
			let summ = Math.ceil(this.PdlData.DebtAll);
			if(summ > 0) {
				this.erramount = parseInt(this.curPay, 10) > parseInt(summ, 10) ? 'Сумма доступна только для оплаты меньше или равной '+summ : '';
			} else {
				this.erramount =  '';
			}

		},
	},
}
</script>

<style scoped>
.v-recurrent {padding: 20px 0;}
.v-recurrent-header {display: flex;justify-content: space-between;}
.v-recurrent-field {width: 292.1875px;padding: unset;margin: 10px 0;}
.v-recurrent-field__title {font-size: 18px;font-weight: bolder;color: #333;}
.v-recurrent-field__error {font-weight: bolder;color: red;}
.v-recurrent-cards {display: flex;justify-content: space-between;height: 160px;}
.item {width: 292.1875px;height: 160px;}
.v-button {padding: 6px 10px;border: 1px solid;color: white;background: rgb(15,87,64);-webkit-transition: 0.3s ease-out;transition: 0.3s ease-out;cursor: pointer;display: inline-block;transition: .3s ease-out;}
.v-button:hover {opacity: .8;background: rgb(61,176,74);}
.v-recurrent .v-recurrent-input {display: flex;text-align: left;justify-content: space-between;}
.item { border: 1px solid transparent;border-radius: 9px;box-shadow: 0 4px 4px #00000040;transition: 0.3s ease-out;/*cursor: pointer;*/margin-bottom: 2.94vw;}
.item label {display: flex;align-items: center;justify-content: space-around;width: 100%;height: 100%;cursor: pointer;}
.cardView {display: flex;flex-direction: column;align-items: center;justify-content: space-around;height: 100%;}
.cardView img {width: 75px;height: 59px;}
</style>
